/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Ai_Feedback_Option_TextInputs */

const en_no_ai_feedback_option_text = /** @type {(inputs: No_Ai_Feedback_Option_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, I do not want to receive feedback on my resume.`)
};

const de_no_ai_feedback_option_text = /** @type {(inputs: No_Ai_Feedback_Option_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein, ich möchte kein Feedback zu meinem Lebenslauf erhalten.`)
};

/**
* | output |
* | --- |
* | "No, I do not want to receive feedback on my resume." |
*
* @param {No_Ai_Feedback_Option_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_ai_feedback_option_text = /** @type {((inputs?: No_Ai_Feedback_Option_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Ai_Feedback_Option_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_ai_feedback_option_text(inputs)
	return en_no_ai_feedback_option_text(inputs)
});